import React, {useState} from "react";
import {Link, useNavigate, useLocation} from "react-router-dom";
import "../../style/error/_error.scss";
import {isNotEmpty} from "../utils/CommonUtil";

interface Error404PageProps{}

const Error404Page: React.FC<Error404PageProps> = ({}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [errorMessage] = useState(location.state?.message);
    return (
        <div className="error-container d-flex justify-content-center text-center vh-100 vw-100">
            <div className="mt-5 mb-5">
                <h1 className="text-danger mb-4" style={{fontFamily: "serif"}}>404 NOT FOUND</h1>
                {!isNotEmpty(errorMessage) &&
                    <p>お探しのページが見つかりませんでした。</p>
                }
                {isNotEmpty(errorMessage) &&
                    <p>{errorMessage}</p>
                }
                <div className="text-center d-flex gap-3 align-content-center align-items-center justify-content-center mt-4 d-none">
                    <Link to="/" onClick={(e) => {
                        navigate("/");
                        e.stopPropagation?.();
                        e.preventDefault?.();
                    }}>トップ</Link>
                </div>
            </div>
        </div>
    );
};

export default Error404Page;